import { DefaultApi } from '../gamma-api';
import { UserAuthApi, TenantAuthApi } from '../auth-api';

import { GAMMA_INTERNAL_API_BASE_PATH, AUTH_SERVER_URL } from './utils/configUtil';

export const defaultApi = new DefaultApi(undefined, GAMMA_INTERNAL_API_BASE_PATH);
export const userAuthApi = new UserAuthApi(undefined, AUTH_SERVER_URL);
export const tenantAuthApi = new TenantAuthApi(undefined, AUTH_SERVER_URL);
